import React, {Dispatch, useEffect, useRef, useState} from 'react';
import "./ReportLinkPopup.scss"
import {CalculatedRainWater, Marker} from "../App";
import * as Yup from 'yup';
import generateReportLink from "./generateReportLink";

const validationSchema = Yup.object().shape({
    email: Yup.string().email('Podaj prawidłowy adres email').required('To pole jest wymagane'),
});


type Props = {
    setShowShare: Dispatch<boolean>,
    calculatedRainWater: CalculatedRainWater,
    marker: Marker,
    link: string,
    setLink: Dispatch<string>,
    reportHash: string,
    setReportHash: Dispatch<string>,
}

type Response = {
    error?: string,
    message?: string,
}


const reqHost = window.location.host == 'localhost:3000' ? 'http://localhost:8000/' : '/';

function ReportLinkPopup({ setShowShare, calculatedRainWater, marker, link, setLink, reportHash, setReportHash }: Props) {
    const [loading, setLoading] = useState<boolean>(true);
    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [showError, setShowError] = useState<boolean>(false);
    const [sendResponse, setSendResponse] = useState<Response|null>(null);

    useEffect(() => {
        getReportLink();
    }, [])

    const getReportLink = async () => {
        if (link !== "" && reportHash !== "") {
            setLoading(false);
            return;
        }

        const data = await generateReportLink(calculatedRainWater, marker);
        if (data) {
            setLink(data.link);
            setReportHash(data.hash);
            setLoading(false);
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setEmail(value);
        validateEmail(value);
    }

    const validateEmail = async (email: string) => {
        try {
            await validationSchema.validate({email});
            setEmailError("");
        } catch (error) {
            // @ts-ignore
            setEmailError(error.errors[0]);
        }
    }

    const sendReport = async (email: string, hash: string) => {
        setShowError(true)

        if (!email) {
            validateEmail(email);
            return;
        }

        if (emailError) {
            return;
        }

        setLoading(true);

        const res: Response = await fetch(
            reqHost + "wp-json/rainwatercalculator/report/send",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    hash
                })
            }
        ).then((response) => response.json());

        setLoading(false);
        setSendResponse(res);
    }

    return (
        <div className="ReportLinkPopup popup">
            <div className="container">
                <div className='row'>
                    <div className='header ms-2 mt-3'>
                        <span className=''><h3>Prześlij raport na email</h3></span>
                        <button type="button" className="btn-close" onClick={() => {setShowShare(false)}}></button>
                    </div>
                    {sendResponse && <div className='row'><div className="m-3">
                        <div className="col-md-12">
                            {sendResponse.error && <div className='send-error'>{sendResponse.error}</div>}
                            {sendResponse.message && <div className='send-success'>{sendResponse.message}</div>}
                        </div>
                        <div className="col-md-12 mt-4 d-flex justify-content-end">
                            <a className='yellow-button' onClick={() => {setShowShare(false)}}>Zamknij</a>
                        </div>
                    </div></div>}

                    {loading && <div className='loading-container '><div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div></div>}
                    {!sendResponse && !loading && link && <div className='row'>
                        <div className="m-3">
                            <div className="col-md-12">
                                <label htmlFor="inputReportLink">Link do raportu</label>
                                <input type="text" className="form-control" id="inputReportLink" value={link} readOnly/>
                            </div>

                            <div className="col-md-12 mt-3">
                                <label htmlFor="inputReportLink">Email</label>
                                <input type="email" className="form-control" id="email" value={email} onChange={handleChange}/>
                                {showError && <span className='error-text'>{emailError}</span>}
                            </div>

                            <div className="col-md-12 mt-4 d-flex justify-content-center">
                                <a className='yellow-button' onClick={() => sendReport(email, reportHash)}>Wyślij raport na email</a>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <div className="background"/>
        </div>
    );
}

export default ReportLinkPopup;
